import { BehaviorSubject } from 'rxjs';
import * as i0 from "@angular/core";
export class AfsReviewService {
    constructor() {
        this.testSubject = new BehaviorSubject([]);
        this.checkCalculateScoreSubject = new BehaviorSubject(null);
        this.testObservable = this.testSubject.asObservable();
        this.checkCalculateScoreObservable = this.checkCalculateScoreSubject.asObservable();
    }
    setTest(dataTest) {
        this.testSubject.next(dataTest);
    }
    returnTest() {
        return this.testObservable;
    }
    setScore(booleanScore) {
        this.checkCalculateScoreSubject.next(booleanScore);
    }
    returnScore() {
        return this.checkCalculateScoreObservable;
    }
}
AfsReviewService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AfsReviewService_Factory() { return new AfsReviewService(); }, token: AfsReviewService, providedIn: "root" });
